import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { SortService } from '@app/components/sorting/SortService';
import { CSVDataService } from '@app/export/CSVDataService';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MemberService } from '@app/services/member.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { MenuItem, SelectItem } from 'primeng/api';
import { Listbox } from 'primeng/listbox';

interface SignType {
  id: number;
  name: string;
}

interface Sign {
  id: number;
  abbreviation: string;
  name: string;
  type: number;
  sort: number;
}

interface IYear {
  year: number;
}

interface IMember {
  id: number;
  givenName: string;
  familyName: string;
  email: boolean;
}

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

@Component({
  selector: 'app-attendance-member-level',
  templateUrl: './attendance-member-level.component.html'
})
export class AttendanceMemberLevelComponent implements OnInit {
  @ViewChild('listbox') listbox: Listbox;
  institutionslist: SelectItem[] = [];
  form;
  memberform;
  
  multiple = false;
  members: IMember[] = [];
  selectedmembers: any[] = [];
  selectedmembersall: any[] = [];
  viewselectedmembers = false;
  viewmembersearch = false;
  selectedinstitutions: any[] = [];

  rangeValues: number[] = [1900, new Date().getFullYear()];
  years: IYear[] = [];
  selectedyears: any[] = [];
  selectedfilter;
  institutionlist: Institution[] = [];
  selectedinstitution;
  selected;

  response;
  signtypelist: SignType[] = [];
  signlist: Sign[] = [];
  notsignlist: Sign[] = [];
  lodges: SelectItem[];
  camps: SelectItem[];
  access;
  items: MenuItem[];
  expanded = true;
  expandedlabel = 'Stäng grupper';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private statisticsService: StatisticsService,
    private memberService: MemberService,
    private institutionService: InstitutionsService,
    private permissionService: PermissionsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clearReport();
      }
    });
  }

  ngOnInit() {
    this.memberform = this.fb.group({
      institutionId: ['', ''],
      memberId: ['', ''],
      givenName: ['', ''],
      familyName: ['', '']
    });
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      selectedFilter: ['', ''],
      institutionId: ['', ''],
      memberType: ['', ''],
      members: [null, null],
      signTypeId: ['', ''],
      signId: ['', ''],
      notSignTypeId: ['', ''],
      notSignId: ['', ''],
      meetingTypeId: ['', ''],
      meetingInstitution: ['', ''],
      selectedYears: [null, null],
      parentInstitutionId: ['', '']
    });

    this.setItems();
    this.getAllInstitutionsFilterList();
    this.getSignTypes();
    this.getSigns();
    this.populateYears();
    this.lodges = [{ label: 'Bröder', value: 'b' }, { label: 'Systrar', value: 'r' }];
    this.camps = [{ label: 'Bröder', value: 'bl' }, { label: 'Systrar', value: 'rl' }];
    this.permissionService.selectedrole.subscribe(r => {
      if (r) {
        this.access = r;
        if (r?.institution) {
        }
      }
    });
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    let firstrow = 'Medlemsid;Förnamn;Efternamn;';
    for (let y of this.selectedyears) {
      firstrow += y + ';';
      firstrow += "Primärloge" + ';';
    }
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'NärvaroPerInstiutionPerMånad_' + datum;
    let data: any[] = [];
    this.response.forEach(x => {
      let row = {
        col1: x.memberId,
        col2: x.givenName,
        col3: x.familyName
      };
      let i = 4;
      for (let a of x.years) {
        row['col' + i] = a.attendanceCount;
        i++;
        row['col' + i] = a.primaryMemberLodge.shortName;
        i++;
      }
      data.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  populateYears() {
    this.years = [];
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      this.years.push({ year: i });
    }
  }
  getSignTypes() {
    this.memberService.getSignTypes().subscribe(response => {
      this.signtypelist = response;
    });
  }

  getSignsBySignType(evt, list) {
    if (Number(evt.target.value) !== 0) {
      this.memberService.getSignsBySignType(Number(evt.target.value)).subscribe(resp => {
        switch (list) {
          case 'signlist': this.signlist = resp;
            break;
          case 'notsignlist': this.notsignlist = resp;
            break;
        }
      });
    } else {
      this.getSigns();
    }
  }

  getSigns() {
    this.memberService.getSigns().subscribe(response => {
      if (response) {
        this.signlist = response;
        this.notsignlist = this.signlist;
      }
    });
  }

  search() {
    this.createReport(this.form);
    this.expanded = false;
    this.expandedlabel = 'Öppna grupper';
  }

  searchMembers() {
    const institutionId = this.form.get('institutionId').value;
    this.memberform.patchValue({ institutionId: institutionId });
    this.memberService.SearchMemberFromInstitutionByNameOrId(this.memberform.value).subscribe(x => {
      if (x) {
        x.email = false;
        this.members = x;
      }
    });
  }

  addSelectedMembers() {
    this.viewselectedmembers = true;
    this.form.patchValue({ members: this.selectedmembers });
  }

  addMember(evt) {
    if (evt.checked) {
      this.selectedmembers.push(Number(evt.source.value.id));
      this.selectedmembersall.push(evt.source.value);
    } else {
      const elementidx = this.selectedmembers.findIndex(m => m === Number(evt.source.value.id));
      this.selectedmembers.splice(elementidx, 1);
      const elementidxall = this.selectedmembersall.findIndex(m => m.id === Number(evt.source.value.id));
      this.selectedmembersall.splice(elementidxall, 1);
    }
  }

  reset(evt) {
    const resetform = {
      lodges: null,
      camps: null,
      institutionId: null,
      parentInstitutionId: null,
      selectedYears: []
    };
    this.selectedinstitution = null;
    if (evt.value !== 3) {
      this.selected = null;
      this.form?.get('institutionId').setValue(null);
      this.selectedmembers = [];
      this.selectedmembersall = [];
      this.memberform?.reset();
      this.members = [];
      this.viewselectedmembers = false;
      this.form?.patchValue({ members: [] });
      this.viewmembersearch = false;
      this.form?.patchValue({ memberType: null });
    }
    this.form?.patchValue(resetform);
    this.selectedyears = [];
  }

  setYears(evt) {
    const years: any[] = [];
    evt?.value.forEach(y => {
      years.push(y.year);
    });
    this.selectedyears = years;
    this.selectedyears.sort((n1, n2) => n1 - n2);
    this.form?.patchValue({ selectedYears: years });
  }

  clearYears() {
    this.years = [];
    this.form?.patchValue({ selectedYears: this.years });
    if (this.listbox) {
      this.listbox.value = [];
    }
    this.populateYears();
  }

  setSingleInstitution(evt) {
    this.form?.patchValue({ institutionId: evt.value });
  }

  getAllInstitutionsFilterList() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutionlist = this.institutionlist.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK1', 'RR1', 'SOFT1', 'SOFT2', 'SL1', 'SGL1'];
      this.institutionlist = this.institutionlist.filter(x => {
        return removelist.indexOf(x.shortName) === -1;
      });
      this.institutionlist.forEach(c => {
        this.institutionslist.push({ label: c.name, value: c.id });
      });
    });
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK1', 'RR1', 'SOFT1', 'SOFT2', 'SL1', 'SGL1'];
      this.institutionlist = this.institutionlist.filter(x => {
        return removelist.indexOf(x.shortName) === -1;
      });
      this.institutionlist.forEach(c => {
        this.institutionslist.push({ label: c.name, value: c.id });
      });
    });
  }

  createReport(evt) {
    this.response = [];
    this.statisticsService.GetAttendanceStatisticsPerMemberReport(evt.value).subscribe((response: any) => {
      if (response) {
        this.response = response;
        this.years = [];
        this.response.forEach(x => {
          if (this.years.indexOf(x.year) === -1) {
            this.years.push(x.year);
          }
        });
      }
      this.populateYears();
    });
  }

  radioSelection(evt) {
    switch (Number(evt.value)) {
      case 1: this.selectedmembers = [];
        this.selectedmembersall = [];
        this.memberform?.reset();
        this.viewselectedmembers = false;
        this.form.patchValue({ members: null });
        this.viewmembersearch = false;
        this.members = [];
        break;
      case 2: this.viewmembersearch = true;
        break;
      case 3: this.selectedmembers = [];
        this.selectedmembersall = [];
        this.memberform?.reset();
        this.viewselectedmembers = false;
        this.form.patchValue({ members: null });
        this.viewmembersearch = false;
        this.members = [];
        break;
    }
  }

  clearReport() {
    this.response = null;
    this.form?.reset();
    this.years = [];
    this.viewselectedmembers = false;
    this.selectedmembersall = [];
    this.memberform?.reset();
    this.selectedmembers = [];
    this.selectedyears = [];
    if (this.listbox) {
      this.listbox.value = [];
    }
    this.populateYears();
  }
}
